import { CarrierNote } from './CarrierNote';
import { CarrierContact } from './CarrierContact';
import { FUMCarrierIdentity } from './FUMCarrierIdentity';
import { CarrierDocument } from './CarrierDocument';
import { CarrierAddress } from './CarrierAddress';
import { CarrierInsurance } from './CarrierInsurance';
import { CarrierAssociation } from './CarrierAssociation';
import { FUMEnterprise } from './FUMEnterprise';
import { BGStatusType } from '../../../app/shared/Enums/BGStatusType';

export const CarrierTrackingPreference = {
  MANUAL: 'Manual',
  PROJECT_44: 'Project 44',
  TRUCKER_TOOLS: 'Trucker Tools'
} as const;

export type CarrierTrackingPreference =
  (typeof CarrierTrackingPreference)[keyof typeof CarrierTrackingPreference];

export class FUMCarrier {
  carrierID: number;
  carrierName: string;
  carrierDbaName: string;
  carrierCode: string;
  customerName: string;
  displayName: string;
  isPay: boolean;
  status: BGStatusType;
  trackingPreference: CarrierTrackingPreference;
  mainAddress: CarrierAddress;
  stateID: string;
  stateIDType: string;
  dotNumber: string;
  mcNumber: string;
  mxNumber: string;
  ffNumber: string;
  scac: string;
  carrierCertifications: string[];
  carrierContacts: CarrierContact[];
  carrierDocuments: CarrierDocument[];
  carrierIdentities: FUMCarrierIdentity[];
  carrierInsurances: CarrierInsurance[];
  carrierNotes: CarrierNote[];
  carrierUserRelations: CarrierAssociation[];
  carrierAddresses: CarrierAddress[];
  enterprises: FUMEnterprise[];
}
